var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"alignment-record",class:("a" + _vm.number),on:{"mouseover":_vm.onOver,"mouseout":_vm.onOut}})}
var staticRenderFns = []

export { render, staticRenderFns }